import React, { useMemo, createContext, useContext, useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

const Question = lazy(() => import("./pages/Question"));
const NotFound = lazy(() => import("./pages/NotFound"));
const RecMatch = lazy(() => import("./pages/RecMatch"));
const MagicBox = lazy(() => import("./pages/MagicBox"));
const NewMagicBox = lazy(() => import("./pages/NewMagicBox"));
const MagicBoxWinner = lazy(() => import("./pages/MagicBoxWinner"));
const NewActivity = lazy(() => import("./pages/NewActivity"));
const MatchStatus = lazy(() => import("./pages/MatchStatus"));
const MatchLogin = lazy(() => import("./pages/MatchStatus/login"));
const Drag = lazy(() => import("./pages/Drag"));

export default () => {
  return (
    <Router>
      {/* Switch:只加载一个页面 */}
      <Suspense fallback={<div>正在加载...</div>}>
        <Switch>
          <Route exact path="/reactApp/newmagicbox" component={NewMagicBox} />
          <Route exact path="/reactApp/drag/:id" component={Drag} />

          {/* <Route exact path="/login" component={MatchLogin} /> */}
          <Route exact path="/reactApp/newactivity/:id" component={NewActivity} />

          <Route exact path="/reactApp/question" component={Question} />
          <Route exact path="/reactApp/recmatch" component={RecMatch} />
          <Route exact path="/reactApp/magicbox" component={MagicBox} />

          <Route exact path="/reactApp/magicboxWinner" component={MagicBoxWinner} />
          {/* 精准匹配exact */}
          {/* <Route exact path="/mine/:id?/:name?" component={Mine} /> */}
          {/* 更精准匹配exact strict */}
          {/* <Route exact strict path="/about" component={About} /> */}
          {/* <Route exact strict path="/shop" component={Shop} /> */}
          {/* 简形式 */}
          {/* <Route path="/demo" render={() => <div>demo</div>} /> */}
          {/* 重定向 */}
          {/* <Redirect from="/my" to="mine" /> */}
          {/* 嵌套路由 */}

          {/* 只写component属性：404 */}
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </Router>
  );
};
